import i18n from "i18n";

/**
 * IM Transport / Firestore-safe character set for Route Code and Run Name.
 * Allowed: A–Z a–z 0–9 ! @ # $ % ^ & * ( ) _ - + = . {
 * Blocked: space, /, \, }, and any other character.
 */
const IM_TRANSPORT_SAFE_CHAR_SET = new Set(
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_-+=.{".split(
    ""
  )
);

const isImTransportSafeChar = (char) =>
  char.length === 1 && IM_TRANSPORT_SAFE_CHAR_SET.has(char);

export const getImTransportInvalidCharsMessage = (fieldLabel) =>
  i18n.t("common.invalidImTransportSafeChars").replace("|", fieldLabel);

export const isImTransportSafeName = (value) => {
  if (value == null || value === "") {
    return true;
  }
  const text = String(value);
  for (let i = 0; i < text.length; i += 1) {
    if (!IM_TRANSPORT_SAFE_CHAR_SET.has(text[i])) {
      return false;
    }
  }
  return true;
};

export const filterImTransportSafeChars = (value) => {
  if (value == null) {
    return "";
  }
  return String(value)
    .split("")
    .filter((char) => IM_TRANSPORT_SAFE_CHAR_SET.has(char))
    .join("");
};

/**
 * Prevent typing characters outside the IM Transport allow-list.
 * Allows control / navigation keys and shortcuts.
 * Optional onBlocked runs when a character was blocked (for inline error + disable Save).
 */
export const preventInvalidImTransportKeyDown = (event, onBlocked) => {
  if (event.ctrlKey || event.metaKey || event.altKey) {
    return false;
  }
  if (event.key.length !== 1) {
    return false;
  }
  if (!isImTransportSafeChar(event.key)) {
    event.preventDefault();
    if (typeof onBlocked === "function") {
      onBlocked();
    }
    return true;
  }
  return false;
};

/** True when paste/input contained characters that were stripped by the allow-list. */
export const hadImTransportUnsafeChars = (text) => {
  if (text == null || text === "") {
    return false;
  }
  return filterImTransportSafeChars(text) !== String(text);
};

/**
 * On paste: keep only allow-listed characters up to maxLength,
 * replacing the current selection.
 */
export const getImTransportSafePasteValue = (
  currentValue,
  pastedText,
  maxLength,
  selectionStart,
  selectionEnd
) => {
  const safePaste = filterImTransportSafeChars(pastedText);
  const start = selectionStart ?? 0;
  const end = selectionEnd ?? start;
  const before = String(currentValue || "").slice(0, start);
  const after = String(currentValue || "").slice(end);
  return (before + safePaste + after).slice(0, maxLength);
};
